export const MARKETING_AND_ANALYTICS_CATEGORIES = [
    'Tests',
    'Analyse',
    'Attribution',
    'Email',
    'Enrichissement',
    'Carte de chaleur',
    'Données brutes',
    'Tableaux de bord',
    'Référents',
    'Sondages',
    'Vidéo',
];
export const ADVERTISING_CATEGORIES = ['Advertising', 'Publicité', 'Gestionnaires de tag'];
export const FUNCTIONAL_CATEGORIES = [
    'Gestion de la relation client',
    'Fidélisation de la clientèle',
    'Liens profonds',
    'Support',
    'Chat en direct',
    'Surveillance de la performance',
    'Personnalisation',
    'Notifications Push & SMS',
    'Sécurité & fraude',
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2F0ZWdvcmllcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zZW50LW1hbmFnZXIvY2F0ZWdvcmllcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxrQ0FBa0MsR0FBRztJQUNoRCxPQUFPO0lBQ1AsU0FBUztJQUNULGFBQWE7SUFDYixPQUFPO0lBQ1AsZ0JBQWdCO0lBQ2hCLGtCQUFrQjtJQUNsQixnQkFBZ0I7SUFDaEIsa0JBQWtCO0lBQ2xCLFdBQVc7SUFDWCxVQUFVO0lBQ1YsT0FBTztDQUNSLENBQUE7QUFFRCxNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLGFBQWEsRUFBRSxXQUFXLEVBQUUsc0JBQXNCLENBQUMsQ0FBQTtBQUUxRixNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBRztJQUNuQywrQkFBK0I7SUFDL0IsOEJBQThCO0lBQzlCLGdCQUFnQjtJQUNoQixTQUFTO0lBQ1QsZ0JBQWdCO0lBQ2hCLGdDQUFnQztJQUNoQyxrQkFBa0I7SUFDbEIsMEJBQTBCO0lBQzFCLG1CQUFtQjtDQUNwQixDQUFBIn0=